import { router } from "@inertiajs/react";
import type { DateValue } from "@internationalized/date";
import { adminAccountMemberPath } from "@travily/routes";
import type AdminAccountsMembersEdit from "@travily/types/pages/AdminAccountsMembersEdit";
import type { ReactNode } from "react";
import { useState } from "react";
import { AdminRoutedModal } from "@/components/AdminRoutedModal";
import { parseDateValue } from "@/pages/admin/accounts/components/person-form-fields";
import { EditView } from "./edit.view";

const AdminAccountMemberEditPage = ({
  membership_id,
  account_id,
  person_name,
  person_date_of_birth,
}: AdminAccountsMembersEdit) => {
  const [name, setName] = useState(person_name);
  const [dateOfBirth, setDateOfBirth] = useState<DateValue | null>(parseDateValue(person_date_of_birth));

  return (
    <AdminRoutedModal>
      {({ close }) => {
        const handleSave = (e: React.FormEvent) => {
          e.preventDefault();
          if (!name.trim()) return;
          router.patch(
            adminAccountMemberPath(account_id, membership_id),
            { person: { name: name.trim(), date_of_birth: dateOfBirth?.toString() ?? null } },
            { preserveState: true, preserveScroll: true, onSuccess: () => close() },
          );
        };

        return (
          <EditView
            name={name}
            dateOfBirth={dateOfBirth}
            onNameChange={setName}
            onDateOfBirthChange={setDateOfBirth}
            onClose={close}
            onSubmit={handleSave}
          />
        );
      }}
    </AdminRoutedModal>
  );
};

AdminAccountMemberEditPage.layout = (page: ReactNode) => page;

export default AdminAccountMemberEditPage;
